import React from 'react';
import flor from '../assets/flor.jpeg';
import lewis from '../assets/lewis.jpeg';

function Team() {
    const team = [
        {
            name: "Flor Ronsmans De Vry",
            title: "Co-Founder & Director",
            bio: "Flor began his professional coding career at just 15 years old when he was recruited by the Belgian government, showcasing his exceptional technical abilities. Over the years, he has developed deep expertise in reverse engineering and navigating sophisticated automation prevention systems. His innovative approach to solving complex technical challenges drives Fuse's product development and technological edge.",
            image: flor
        },
        {
            name: "Lewis J.",
            title: "Co-Founder & Director",
            bio: "Lewis is the visionary behind PulsarAIO, credited as the world's first auto-clicker, bringing nearly a decade of specialized experience in desktop application development. His extensive knowledge of reverse engineering and low-level system optimization has been key to building Fuse's high-performance products.",
            image: null
        }
    ];

    return (
        <div className="py-16 md:py-24">
            <div className="text-center mb-12 md:mb-16">
                <h2 className="text-3xl md:text-5xl font-bold text-white mb-4">
                    Meet the Team
                </h2>
                <p className="text-lg md:text-xl text-gray-400">
                    Led by industry experts in automation and reverse engineering
                </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 max-w-6xl mx-auto">
                {team.map((member, index) => (
                    <div 
                        key={index}
                        className="bg-gradient-to-br from-gray-800/50 to-gray-900/50 border border-gray-700 rounded-2xl p-8 md:p-10 text-center hover:border-fuse-orange transition-colors"
                    >
                        {/* Avatar */}
                        <div className="w-32 h-32 md:w-40 md:h-40 mx-auto mb-6 rounded-full overflow-hidden border-4 border-fuse-orange/30">
                            {member.image ? (
                                <img 
                                    src={member.image} 
                                    alt={member.name}
                                    className="w-full h-full object-cover"
                                />
                            ) : (
                                <div className="w-full h-full bg-gradient-to-br from-fuse-orange to-orange-700 flex items-center justify-center text-white text-5xl md:text-6xl font-bold">
                                    {member.name.charAt(0)}
                                </div>
                            )}
                        </div>

                        <h3 className="text-2xl md:text-3xl font-bold text-white mb-2">
                            {member.name}
                        </h3>
                        
                        <p className="text-fuse-orange font-semibold mb-6 text-lg">
                            {member.title}
                        </p>

                        <p className="text-gray-300 leading-relaxed text-left">
                            {member.bio}
                        </p>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default Team;

